<template>
  <div class="panel panel-default">
    <loading-spinner v-if="loading"/>

    <div v-else class="panel-body">
      <div class="pull-right">
        <button type="button" class="btn btn-white" @click="year = year - 1">
          <i class="fa fa-chevron-left"></i>
        </button>

        {{ year }}

        <button type="button" class="btn btn-white" @click="year = year + 1">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>

      <form @submit.prevent="submit">
        <table class="table table-condensed table-striped">
          <thead>
          <tr>
            <th :class="'col-xs-' + checkboxWidth">
            </th>

            <th :class="'col-xs-' + periodWidth">
              {{ label }}
            </th>

            <th v-for="target in targets" :class="'col-xs-' + target.width">
              {{ target.label }}
            </th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(row, index) in rows">
            <td class="text-center">
              <input type="checkbox" :value="row" v-model="selected">
            </td>

            <td>
              {{ row.label }}
            </td>

            <td v-for="target in targets" :class="{'has-error': hasError(index, target.name)}">
              <input v-model="row.values[target.name]" type="text" class="form-control input-sm">

              <span class="help-block" v-if="hasError(index, target.name)">
                  {{ getError(index, target.name) }}
              </span>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <button
                  type="button"
                  class="btn btn-sm btn-block"
                  style="background-color: transparent"
                  @click="reset"
              >
                <i class="fa fa-check"></i> Set All
              </button>
            </td>

            <td v-for="target in targets">
              <input v-model="resetValues[target.name]" type="text" class="form-control input-sm">
            </td>
          </tr>
          </tbody>

          <tfoot>
          <tr>
            <td colspan="2">
              <b>
                Total
              </b>
            </td>

            <td v-for="target in targets">
              {{ rows.reduce((total, row) => total + parseFloat(row.values[target.name]), 0) | number }}
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <b>
                Selected Total
              </b>
            </td>

            <td v-for="target in targets">
              {{ selected.reduce((total, row) => total + parseFloat(row.values[target.name]), 0) | number }}
            </td>
          </tr>
          </tfoot>
        </table>

        <button type="submit" class="btn btn-block btn-black">
          <i class="fa fa-save"></i> Save
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import LoadingSpinner from '../../../Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  props: {
    endpoint: {
      required: true,
      type: String
    },

    targets: {
      required: true,
      type: Array
    },

    label: {
      required: true,
      type: String
    },

    checkboxWidth: {
      required: false,
      default: 3
    },

    periodWidth: {
      required: false,
      default: 3
    }
  },

  data() {
    return {
      rows: null,

      selected: [],

      resetValues: this.targets.reduce((result, target) => {
        return {...result, [target.name]: 0}
      }, {}),

      loading: true,
      errors: {},

      year: moment().year()
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    }
  },

  methods: {
    load() {
      this.loading = true

      this.selected = []

      http.get(this.endpoint + '/' + this.year).then(response => {
        this.rows = response.data.data.map(row => ({id: row.id, ...row.attributes}))

        this.loading = false
      })
    },

    submit() {
      this.errors = {}

      http.put(this.endpoint + '/' + this.year, this.rows).then(response => {
        notify.success('The targets were saved.')

        this.rows = response.data.data.map(row => ({id: row.id, ...row.attributes}))
      }).catch(error => {
        if (error.response.status === 422) {
          return this.errors = error.response.data.errors
        }

        throw error
      })
    },

    hasError(index, target) {
      return this.getError(index, target) != null
    },

    getError(index, target) {
      return (this.errors[index + '.values.' + target] || [])[0]
    },

    reset() {
      this.selected = []

      this.rows = this.rows.map(row => {
        return {...row, values: {...this.resetValues}}
      })

      this.resetValues = this.targets.reduce((result, target) => {
        return {...result, [target.name]: 0}
      }, {})
    }
  }
}
</script>
